import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/schedules/get/list.ts
var list_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var PartnerDataSchema = z.object({ facebookPartnerData: z.object({
	crossposts: z.array(z.object({ destinationId: z.string() })),
	destinationId: z.string().optional(),
	thumbnailUploaded: z.boolean().optional(),
	type: z.enum([
		"yt_create_new",
		"fb_timeline",
		"fb_event",
		"fb_page",
		"fb_group",
		"ig_create_new",
		"tt_create_new"
	]).optional()
}) });
var ContentDestinationScheduleSchema = z.object({
	autoArchive: z.boolean(),
	autoArchivePlaylists: z.array(z.string()).optional(),
	channelId: z.string().optional(),
	description: z.string().optional(),
	durationSeconds: z.number().optional(),
	id: z.string(),
	imageUrl: z.string().optional(),
	leadTimeMillis: z.number().optional(),
	mediaId: z.string().optional(),
	partnerData: PartnerDataSchema.optional(),
	privacy: z.enum([
		"public",
		"friends_of_friends",
		"all_friends",
		"private",
		"unlisted"
	]).optional(),
	publishStatus: z.enum([
		"created",
		"ready",
		"unpublished",
		"published",
		"scheduled_unpublished",
		"scheduled_published",
		"completed"
	]).optional(),
	published: z.boolean(),
	realtimePlayback: z.boolean(),
	revision: z.number().optional(),
	rtmpDestinationId: z.string().optional(),
	startTimeOffsetMillis: z.number(),
	title: z.string(),
	type: z.enum([
		"EMBED",
		"FACEBOOK",
		"RSP_SOURCE",
		"SAVEONLY",
		"RTMP",
		"YOUTUBE"
	]),
	webEncoderProfileId: z.string().optional(),
	webEventProfileId: z.string().optional(),
	webEventProfileName: z.string().optional()
});
var EncoderScheduleSchema = z.object({
	durationMillis: z.number(),
	encoderId: z.string(),
	encoderName: z.string(),
	encoderProfileId: z.string().optional(),
	encoderProfileName: z.string().optional(),
	eventProfileId: z.string(),
	eventProfileName: z.string(),
	id: z.string(),
	localStartTime: z.string(),
	rrule: z.string().optional(),
	title: z.string()
});
var ContentScheduleSchema = z.object({
	contentDestinationSchedules: z.array(ContentDestinationScheduleSchema),
	customerId: z.string(),
	description: z.string().optional(),
	durationSeconds: z.number().optional(),
	enabled: z.boolean(),
	encoderSchedule: EncoderScheduleSchema.optional(),
	endDay: z.string().optional(),
	id: z.string(),
	imageUrl: z.string().optional(),
	localStartTime: z.string(),
	occurrences: z.array(z.object({
		endTime: z.string(),
		startTime: z.string()
	})).optional(),
	origination: z.enum([
		"API",
		"PRO_PRESENTER",
		"MANUAL_START_FROM_ENCODER_EVENT",
		"RSP_EGRESS_CALLBACK",
		"EVENT_UPLOAD_CALLBACK",
		"GO_LIVE"
	]).optional(),
	rrule: z.string().optional(),
	sourceEventId: z.string().optional(),
	startDay: z.string(),
	streamType: z.enum([
		"SIMLIVE",
		"LIVE",
		"REPUBLISH",
		"EXISTING_ENCODER_EVENT",
		"EXISTING_MEDIA"
	]),
	syncDetails: z.boolean(),
	timeZone: z.string(),
	title: z.string()
});
var ResponseSchema = z.array(ContentScheduleSchema);
var parse = parseFactory(ResponseSchema);
//#endregion
export { list_exports };

//# sourceMappingURL=list.js.map